import React from 'react';

import { CircleXIcon } from 'lucide-react';

export const UnsatisfiedRequirementIcon: React.FC = () => (
  <CircleXIcon className="inline-block size-4 text-destructive" />
);
